import queryString from 'query-string';
import { SICLLocale } from './types';

/**
 * Parse a numeric value from a query parameter.
 *
 * @internal
 */
export var parseNumericQueryParameter = function parseNumericQueryParameter(queryParam) {
  return typeof queryParam === 'string' && parseInt(queryParam, 10) || undefined;
};

/**
 * Stringify a query.
 *
 * This function can be used to add a `?` prefix to the query. The prefix will
 * not be added, however, if the query is empty.
 *
 * @internal
 */
export var queryStringify = function queryStringify() {
  var result = queryString.stringify.apply(queryString, arguments);
  return result && "?".concat(result);
};

/**
 * Parse a query string into an object.
 *
 * @internal
 */
export var queryParse = function queryParse(query) {
  return queryString.parse(query);
};

/**
 * Make an ID sequence generator function with a configurable ID prefix (namespace).
 *
 * @internal
 */
export var makeIdSequenceGenerator = function makeIdSequenceGenerator(idPrefix) {
  var currentId = 1;
  return function () {
    var nextId = currentId++;
    return "".concat(idPrefix, "-").concat(nextId);
  };
};

/**
 * This function can be used to mark unreachable code paths.
 *
 * @internal
 */
export var nonThrowingUnreachable = function nonThrowingUnreachable(conditionVariable) {
  console.error('Unreachable code reached (non-throwing)', {
    conditionVariable: conditionVariable
  });
};

/** @internal */
export var getLocaleFromString = function getLocaleFromString(input) {
  return SICLLocale[input] || SICLLocale.fi_FI;
};

/** @internal */
export var clamp = function clamp(value, min, max) {
  return (
    // Clamp value to be in between min and max (inclusive)
    Math.min(max, Math.max(min, value))
  );
};